export default "__VITE_ASSET__D8dks0X5__"